// src/composables/useAuthAccess.ts
import { computed } from 'vue'
import { useAuthStore } from '@/store/auth';

export function useAuthAccess() {
    const auth = useAuthStore()

    const hasPermission = (permission: string) => {
        return auth.permissions.includes(permission)
    }

    const hasAnyPermission = (permissions: string[]) => {
        return permissions.some(p => hasPermission(p))
    }

    const hasRole = (role: string) => {
        return auth.roles.includes(role)
    }

    const hasAnyRole = (roles: string[]) => {
        return roles.some(r => hasRole(r))
    }

    return {
        hasPermission,
        hasAnyPermission,
        hasRole,
        hasAnyRole,
    }
}
